"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformBufferProvider = void 0;
/**
 * @public
 */
class TransformBufferProvider {
    constructor(binder) {
        this.binder = binder;
    }
    getBufferLayout() {
        return this.binder.getBufferLayout();
    }
    setBufferLayout(buffer) {
        this.binder.setBufferLayout(buffer);
    }
}
exports.TransformBufferProvider = TransformBufferProvider;
//# sourceMappingURL=transform-buffer-provider.js.map